import React, { useEffect } from "react";
import "../App.css";
import { CatalogTableSurface } from "./CatalogTableSurface";

export function Divisions({
  divisions,
  setTabName,
  setOpts,
  setIsVisible,
  selectedExportRows = {},
  exportStatus,
  onClearExportSelection,
  onExportCsv,
  onToggleExportRow,
  onToggleVisibleExportRows,
}) {
  useEffect(() => {
    setTabName("divisions-tab");
    setOpts({})
    setIsVisible({ divisions: false, object: false, applyButton: false })
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const divisionsList = divisions || [];
  const allVisibleSelected = divisionsList.length > 0 && divisionsList.every((division) => selectedExportRows[division.id]);

  return (
    <CatalogTableSurface
      allVisibleSelected={allVisibleSelected}
      exportStatus={exportStatus}
      onClearSelection={onClearExportSelection}
      onExportCurrent={() => onExportCsv({ mode: "current", records: divisionsList })}
      onExportFiltered={() => onExportCsv({ mode: "all" })}
      onExportSelected={() => onExportCsv({ mode: "selected" })}
      onSelectVisible={(checked) => onToggleVisibleExportRows(divisionsList, checked)}
      rowCount={divisionsList.length}
      selectedCount={Object.keys(selectedExportRows).length}
      title="Divisions"
    >
      <table className="table">
      <thead>
        <tr>
          <th aria-label="Select rows" className="select-column"></th>
          <th className="count-column">Count</th>
          <th>Division Name</th>
          <th>Division Id</th>
        </tr>
      </thead>
      {divisions ? (
        <tbody>
          {divisionsList.map((division, index) => {
            return (
              <tr key={division.id}>
                <td className="select-column">
                  <input
                    aria-label={`Select ${division.name} for export`}
                    checked={Boolean(selectedExportRows[division.id])}
                    onChange={(event) => onToggleExportRow(division, event.target.checked)}
                    type="checkbox"
                  />
                </td>
                <th className="index count-column">{index + 1}</th>
                <td>{division.name}</td>
                <td>
                  <kbd className="kbd">{division.id}</kbd>
                </td>
              </tr>
            );
          })}
        </tbody>
      ) : (
        <h1>Loading...</h1>
      )}
      </table>
    </CatalogTableSurface>
  );
}
